import styled from 'styled-components';
import { font } from '../../styles/typography';

const ROLE_COLORS = {
  USER: { bg: 'var(--spark-color-success-surface)', color: 'var(--spark-color-success-text)' },
  EMPLOYEE: { bg: 'var(--spark-color-success-surface)', color: 'var(--spark-color-success-text)' },
  ADMIN: { bg: 'var(--spark-color-category-accent-surface)', color: 'var(--spark-color-category-accent-text)' },
  ADMIN_ORG: { bg: 'var(--spark-color-error-surface)', color: 'var(--spark-color-error-text)' },
  DIRECTOR_ORG: { bg: 'var(--spark-color-warning-surface)', color: 'var(--spark-color-warning-text)' },
  COMMERCIAL_DIRECTOR: { bg: 'var(--spark-color-info-surface)', color: 'var(--spark-color-info-text)' },
  DIRECTOR_DEPT: { bg: 'var(--spark-color-error-surface)', color: 'var(--spark-color-error-text)' },
  CURATOR: { bg: 'var(--spark-color-info-surface)', color: 'var(--spark-color-info-text)' },
};

const ROLE_LABELS = {
  USER: 'Співробітник',
  EMPLOYEE: 'Співробітник',
  ADMIN: 'Адміністратор',
  ADMIN_ORG: 'Адмін орг.',
  DIRECTOR_ORG: 'Директор орг.',
  COMMERCIAL_DIRECTOR: 'Ком. директор',
  DIRECTOR_DEPT: 'Директор підр.',
  CURATOR: 'Куратор',
};

const Wrapper = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  ${font('sm')}
  font-weight: 500;
  background: ${(p) => (ROLE_COLORS[p.$role]?.bg || 'var(--spark-color-surface-muted)')};
  color: ${(p) => (ROLE_COLORS[p.$role]?.color || 'var(--spark-color-text-secondary)')};
`;

const DELETION_COLORS = {
  true: { bg: 'var(--spark-color-error-surface)', color: 'var(--spark-color-error-text)' },
  false: { bg: 'var(--spark-color-success-surface)', color: 'var(--spark-color-success-text)' },
};

const StatusDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background: ${(p) => (DELETION_COLORS[p.$deleted]?.bg || 'var(--spark-color-border)')};
`;

export default function Badge({ role, active, deleted }) {
  if (role) {
    const colors = ROLE_COLORS[role] || { bg: 'var(--spark-color-surface-muted)', color: 'var(--spark-color-text-secondary)' };
    return <Wrapper $role={role}>{ROLE_LABELS[role] || role}</Wrapper>;
  }

  // deletionMark: true = помечен удаленным, false = активен
  if (deleted !== undefined) {
    return (
      <span style={{ display: 'flex', alignItems: 'center', fontSize: 13 }}>
        <StatusDot $deleted={deleted} />
        <span style={{ color: deleted ? 'var(--spark-color-error-text)' : 'var(--spark-color-success-text)' }}>
          {deleted ? 'Видалено' : 'Активний'}
        </span>
      </span>
    );
  }

  // legacy isActive support
  if (active !== undefined) {
    return (
      <span style={{ display: 'flex', alignItems: 'center', fontSize: 13 }}>
        <StatusDot $deleted={!active} />
        <span style={{ color: active ? 'var(--spark-color-success-text)' : 'var(--spark-color-error-text)' }}>
          {active ? 'Активний' : 'Неактивний'}
        </span>
      </span>
    );
  }

  return null;
}

export { ROLE_COLORS, ROLE_LABELS };
